import { type FC } from "react";

import { SearchableCard, Spacing } from "@snapchat/snap-design-system";
import { useIntl } from "react-intl";

import { type Container } from "../../../core/models";
import { type LensSpace } from "../../../gql-generated/types";
import { SearchContainer } from "../../../layout/components";
import { useSelectedOrganizationContainer } from "../../hooks";
import { SearchableListContainer, SearchableListSizeConfig } from "../../styles";
import { ContainerDisplay } from "../ContainerDisplay";

import { ListOfFolders } from "./FolderSearchList.styles";
import { messages } from "./messages.generated";

interface FolderSearchListProps {
    searchText: string;
    setSearchText: (searchText: string) => void;
    lensFoldersList: readonly LensSpace[];
    // all containers map
    containersIndex: Map<string, Container>;
    headerChildren?: React.ReactNode;
}

export const FolderSearchList: FC<FolderSearchListProps> = ({
    searchText,
    setSearchText,
    lensFoldersList,
    containersIndex,
    headerChildren,
}) => {
    const { uniqueId } = useSelectedOrganizationContainer();
    const intl = useIntl();

    const lensFolders = lensFoldersList.filter(({ id, name }) => name.includes(searchText) || id.includes(searchText));

    return (
        <SearchableListContainer
            height={SearchableListSizeConfig.height + Spacing.MD}
            width={SearchableListSizeConfig.width}
        >
            {headerChildren}
            <SearchableCard
                onSearch={setSearchText}
                searchValue={searchText}
                searchPlaceholder={intl.formatMessage(messages.searchFolders)}
                padBody={false}
                searchTestId="folder-search__search-box"
            >
                <SearchContainer
                    loading={false}
                    height={SearchableListSizeConfig.height}
                    noResults={lensFolders.length === 0}
                >
                    <ListOfFolders>
                        {lensFolders
                            .map((lensFolder) => {
                                const lensFolderContainer = containersIndex.get(lensFolder.id);
                                if (!uniqueId || !lensFolderContainer) {
                                    return null;
                                }

                                return (
                                    <ContainerDisplay
                                        key={lensFolderContainer.id}
                                        container={lensFolderContainer}
                                        selectedContainerId={uniqueId}
                                        orgId={lensFolder.organizationId}
                                        lensFolderId={lensFolderContainer.id}
                                    />
                                );
                            })
                            .filter((el) => !!el)}
                    </ListOfFolders>
                </SearchContainer>
            </SearchableCard>
        </SearchableListContainer>
    );
};
